export default function MySQL_LTRIM() {
  return (
    <div>
      <h2>MySQL_LTRIM</h2>    </div>
  );
}